import { render, staticRenderFns } from "./NewSante.vue?vue&type=template&id=b63af7e8&scoped=true"
import script from "./NewSante.vue?vue&type=script&lang=js"
export * from "./NewSante.vue?vue&type=script&lang=js"
import style0 from "./NewSante.vue?vue&type=style&index=0&id=b63af7e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63af7e8",
  null
  
)

export default component.exports